module.exports = __webpack_public_path__ + "img/flayer-jungle-run.503643c9.png";